import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import DetectorController from '../../controller/DetectorController';
import { useNavigate } from 'react-router-dom';
import ConfirmModal from '../../components/modal/ConfirmModal';
import toast from 'react-hot-toast';

interface InputStoreProps {
  storeList: HotelSelectType[];
  storeType: number;
  selected: any;
  setSelected: any;
}

type HotelSelectType = {
  name: string;
  store_id: number;
  user_id: number;
};

const RenderFilterStore = ({ storeList, storeType, selected, setSelected }: InputStoreProps) => {
  const [keyword, setKeyword] = useState<string>('');
  const [searchedList, setSearchedList] = useState<HotelSelectType[]>([]);

  const getSearchResult = () => {
    if (storeType === 0) {
      setSearchedList(storeList.filter((item) => item.name.includes(keyword)));
    } else {
      getStoreByName();
    }
  };

  const getStoreByName = async () => {
    try {
      const oData = {
        store_name: keyword,
      };
      const response = await DetectorController.getStoreByName(oData);

      if (response && response.data) {
        const formattedStoreList = response.data.data.map((item: any) => ({
          name: item.store_name,
          store_id: item.store_id,
          user_id: item.user_id,
        }));
        setSearchedList(formattedStoreList);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  useEffect(() => {
    setKeyword('');
    setSelected(null);
    if (storeType === 0) {
      getSearchResult();
    } else {
      getStoreByName();
    }
  }, [storeList, storeType]);

  return (
    <div className="storeListWrap">
      <div className="inputWrap">
        <input
          value={keyword}
          placeholder="매장명 또는 호텔명을 입력하세요"
          onChange={(e) => setKeyword(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              getSearchResult();
            }
          }}
        />
        <button onClick={getSearchResult}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_search.svg`} alt="search" />
        </button>
      </div>
      <div className="storeList">
        {searchedList.length > 0 ? (
          searchedList.map((item, index) => (
            <label key={item.store_id}>
              <input
                type="radio"
                name="hotel"
                value={selected}
                checked={selected === item.store_id}
                onChange={() => setSelected(item.store_id)}
              />
              <p>{item.name}</p>
            </label>
          ))
        ) : (
          <h2>검색 결과가 없어요</h2>
        )}
      </div>
    </div>
  );
};

const DeleteStore = () => {
  const navigate = useNavigate();
  const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);
  const [storeList, setStoreList] = useState<HotelSelectType[]>([]);
  const [storeType, setStoreType] = useState<number>(0);
  const [selected, setSelected] = useState<number>();

  const getHotelList = async () => {
    try {
      const response = await DetectorController.getHotelList();

      if (response && response.data) {
        const formattedHotelList = response.data.data.map((item: any) => ({
          name: item.store_name,
          store_id: item.store_id,
          user_id: item.user_id,
        }));
        setStoreList(formattedHotelList);
      }
    } catch (err) {
      console.log('getHotelList err-->', err);
    }
  };
  const releaseStore = async () => {
    try {
      const oData = {
        store_id: selected,
      };
      const response = await DetectorController.releaseStore(oData);
      if (response && response.data.ok) {
        setVisibleConfirm(false);
        toast.success('해제가 완료되었습니다.');
        window.location.reload();
      }
    } catch (err) {
      console.log('releaseStore err-->', err);
    }
  };

  useEffect(() => {
    getHotelList();
  }, []);

  return (
    <Style>
      <div className="wrap">
        <button className="backButton" onClick={() => navigate('/dashboard')}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_home.svg`} alt="뒤로가기버튼" />
        </button>
        <h2 className="title">매장/호텔 삭제</h2>
        <div className='noticeBox'>해제된 매장/호텔은 영구적으로 삭제되며 복구할 수 없습니다.</div>
        <div className="selectBoxWrap">
          <button className={`${storeType === 0 && 'active'}`} onClick={() => setStoreType(0)}>
            호텔
          </button>
          <button className={`${storeType === 1 && 'active'}`} onClick={() => setStoreType(1)}>
            매장
          </button>
        </div>
        <RenderFilterStore
          storeList={storeList}
          storeType={storeType}
          selected={selected}
          setSelected={setSelected}
        />
        <button onClick={() => setVisibleConfirm(true)} className="deleteButton">
          해지하기
        </button>
      </div>
      <ConfirmModal
        isOpen={visibleConfirm}
        title={'해제된 매장/호텔은 영구적으로\n삭제되며 복구할 수 없습니다.'}
        onConfirmText="삭제"
        onCancelText="취소"
        onConfirm={releaseStore}
        onCancel={() => setVisibleConfirm(false)}
      />
    </Style>
  );
};

export default DeleteStore;

const Style = styled.div`
  /* wrap */
  .wrap {
    width: 100%;
    min-height: 100vh;
    padding: 30px 3vw;

    h1 {
      margin-bottom: 6px;
    }
  }

  /* noticeBox */
  .noticeBox{
    margin-top: 50px;
    background:#FFEBEB;
    color: #FF6060;
    font-weight: 700;
    padding: 10px 20px;
    border-radius: 10px;
  }
  /* selectBoxWrap */
  .selectBoxWrap {
    margin: 10px 0 30px 0;

    button {
      width: 50%;
      padding: 12px 0;
      background: #f7f7f7;
      border: 1px solid #cecece;
      margin: -1px;
    }
    button:nth-child(1) {
      border-radius: 5px 0px 0px 5px;
    }
    button:nth-child(2) {
      border-radius: 0 5px 5px 0;
    }
  }
  button.active {
    border: 1px solid #4dd2ae;
    background: #ecf5f3;
    color: #40977f;
    z-index: 10;
  }

  /* storeListWrap */
  .storeListWrap {
    margin-bottom: 100px;

    .inputWrap {
      display: flex;
      margin-bottom: 10px;

      input {
        width: 80%;
        border: none;
        border-bottom: 1px solid #333;
        background: none;
        outline: none;
      }
      button {
        padding: 6px 40px 4px 40px;
        background: #333;
        border: none;
        outline: none;
        border: none;
        border-radius: 4px;

        img {
          width: 20px;
        }
      }
    }
  }

  /* storeList */
  .storeList {
    width: 100%;
    background: #fff;
    display: inline-flex;
    flex-wrap: wrap;

    h2 {
      margin-top: 24px;
      font-weight: 400;
      font-size: 16px;
    }
    label {
      width: 25%;
      display: flex;
      align-items: center;
      gap: 2%;
      cursor: pointer;
    }
    input {
      width: 16px;
      height: 16px;
      accent-color: #40977f;
    }
  }

  /* deleteButton */
  .deleteButton {
    width: 90%;
    position: fixed;
    bottom: 10px;
    background: #333;
    color: #fff;
    padding: 14px 0;
    border-radius: 4px;
    border: none;
    outline: none;
    font-size: 18px;
  }

  @media (max-width: 800px) {
    .storeList {
      label {
        width: 50%;
      }
    }
  }
`;
